import http from '../helpers/http';

const DeviceToken = (token: string) => {
  const headers = {
    'x-access-token': token,
  };

  return {
    request: async (deviceId: string, platform?: string) => {
      const result = await http.post('/auth/device-token', { deviceId, platform }, { headers });
      return result?.data?.data?.deviceToken || '';
    },
    revoke: async (deviceId: string) => {
      await http.delete('/auth/device-token', { headers, data: { deviceId } });
      return true;
    },
    loginPublic: async (deviceToken: string, deviceId: string) => {
      const result = await http.post('/auth/device-login', { deviceToken, deviceId }, {});
      return result?.data?.data || {};
    },
  };
};

export default DeviceToken;
